import React from "react";

export const Conteudo = () => {
  return (
    <div className={"p-2 p-lg-5 conteudo_pagina"}>
      <h1>
        Grupo Fechado Só para Glamgirls no Facebook
      </h1>

      <div className={"level-2"}>
        <div className={"capa_face"}></div>
        <div className={"gb-contentblock p-2 p-lg-5"}>
          <p>
            Só Glamgirls podem fazer parte da nossa plataforma online onde trocamos dicas, experiências, recebem novidades Glambox em primeira mão e acessam lives exclusivas com experts de beleza todas às quartas-feira.
          </p>
          <p>
            Para fazer parte é muito simples: deixe sua assinatura ativa e solicite seu acesso no grupo respondendo duas perguntas obrigatórias com e-mail de cadastro da sua assinatura Glambox e CPF. É muito importante que nos passe essas informações para localizarmos sua assinatura e aceitarmos a sua entrada!
          </p>

          <a href={"https://www.facebook.com/groups/370139723645396/"} target={"_blank"} className={"btn btn-md"}>Faça parte!</a>
        </div>
      </div>
    </div>
  );
};
